import { render, staticRenderFns } from "./ScanResult.vue?vue&type=template&id=ddbc3926&scoped=true&"
import script from "./ScanResult.vue?vue&type=script&lang=js&"
export * from "./ScanResult.vue?vue&type=script&lang=js&"
import style0 from "./ScanResult.vue?vue&type=style&index=0&id=ddbc3926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbc3926",
  null
  
)

export default component.exports